export class Parallax {
    init($sections)
    {
        if ($(window).width() > 1020)
        {
            $(window).scroll(function ()
            {
                var wScrollTop = $(window).scrollTop();
                $('[data-parallax="true"]').each(function (id, item)
                {
                    if ($(this).visible(true))
                    {
                        var itemTop = $(this).offset().top;
                        var s = wScrollTop - (itemTop);
                        $(this).find('.parallax-bg').css({
                            'transform': 'translateY(' + (s * 0.3) + 'px)',
                            '-webkit-transform': 'translateY(' + (s * 0.3) + 'px)',
                            '-moz-transform': 'translateY(' + (s * 0.3) + 'px)'
                        });
                    }
                });
            });
        }
    }
}